import '../css_styles/button_styles.css'
import '../css_styles/window_canvas_styles.css'

// imports relevant for HTTP calls
import { useAuth0 } from '@auth0/auth0-react';
import DisplayException from '../error_messages/DisplayException';
import CircleLoader from 'react-spinners/CircleLoader';
import { SERVER_URL } from '../config_server_url';

// ----- Imports for main window --------
import YesNoPopup from '../popup_windows/YesNoPopup';
import InfoPopup from '../popup_windows/InfoPopup';
import FactorTableEditorCycle from './FactorTableEditorCycle';
import FactorTableValidation from './FactorTableValidation';
import UserSessionContext from '../user_session/context_user_session';
import SelectOptionPopup from '../popup_windows/SelectOptionPopup';

import { useContext, useState, useEffect } from 'react';

function DesignSpaceEditorCycle(props) {

    const { user } = useAuth0();
    const usr_session_ctx = useContext(UserSessionContext);

    const [showPopup, setShowPopup] = useState(false);
    const [modifications, setModifications] = useState(false);
    const [showNoModificationDetected, setShowNoModificationDetected] = useState(false)
    const [showUpdateSuccess, setShowUpdateSuccess] = useState(false);
    const [showCreateSuccess, setShowCreateSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    // ------------------ Display HTTP/Server Exceptions ---------------------------------
    const [Exception, setException] = useState(false);
    const [ExceptionMessage, setExceptionMessage] = useState('');
    
    // ------------------ General Window Layout -----------------------------
    const [factors, setFactors] = useState([]);
    const [title, setTitle] = useState('');
    const [triggerSave, setTriggerSave] = useState(0);

    const [uuidDesignSpace, setUuidDesignSpace] = useState('');

    // ------------------ Display Object Validation Information/Warnings/Errors  ---------------------------------
    const [validated, setValidated] = useState(true);
    const [validationWindow, setValidationWindow] = useState(false);
    const [validationMessage, setValidationMessage] = useState([]);
    const [showPopupApplyAllCycles, setShowPopupApplyAllCycles] = useState(false)


    useEffect( () => {
        if (props.campaign_objects.uuid_design_space !== '') {
            setUuidDesignSpace(props.campaign_objects.uuid_design_space)
            setIsLoading(true);
            const fetchDesignSpace = async () => {
                    setIsLoading(true);
                    const uuid_design_space = props.campaign_objects.uuid_design_space;
                try {
                    const response = await fetch(`${SERVER_URL}/current_project/load_design_space/`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'uuid_tenant': usr_session_ctx.uuid_tenant
                        },
                        body: JSON.stringify(uuid_design_space),
                    });
        
                    if (!response.ok) {
                        throw new Error(`HTTP error ${response.status}`);
                    }
                    const data = await response.json();
                    setFactors(data.data.factors);
                    setTitle(data.data.title);
                    setIsLoading(false);
                } catch (err) {
                    setIsLoading(false);
                    setException(true);
                    setExceptionMessage(`HTTPException: err_msg=${err.message}`);
                } 
            };
            fetchDesignSpace();
        }
    }, [props.campaign_objects.uuid_design_space ]);


// ------------ Functions to Handle Save Experimental Setup --------------------------
    async function handleSave() {
        if (modifications === false && validated) {
            setShowNoModificationDetected(true);
            return;
        }
        if (props.cycleId === 0) {
            // if first cycle we can just save modifications of DesignSpace objects
            await saveDesignSpace()
        }
        if (props.cycleId > 0) {
            // if there are previous cycles, we let the user decide if the modfication are save to be applied to globally to all cycles that are based 
            // on the design space, or if a new object DesignSpace should be crated for this cycle and potnetially following cycles
            if(props.campaign_objects_prevcycle.uuid_design_space === props.campaign_objects.uuid_design_space){
                setShowPopupApplyAllCycles(true);
            }
            else{
                // if we update a workflow again for the same cycle there is not reason to re-create the DesignSpace object that was not used yet
                await saveDesignSpace()
            }
        }
    }

    async function apply2AllPrevCycles(){
        await saveDesignSpace();
        setShowPopupApplyAllCycles(false);
    }

    async function saveAsNew(){
        await saveDesignSpaceAsNew();
        setShowPopupApplyAllCycles(false);
    }

    async function saveDesignSpace(){
        setIsLoading(true);
        try{
            let data_design_space = { uuid_project: usr_session_ctx.session_info.uuid_current_project,
                                      uuid_opt_campaign: props.uuid_opt_campaign,
                                      title: title, 
                                      factors: factors, 
                                      uuid_design_space: uuidDesignSpace};
            let headers = {
                'Content-Type': 'application/json',
                'auth0_user': user.sub,
                'uuid_tenant': usr_session_ctx.uuid_tenant
            };
            const response = await fetch(`${SERVER_URL}/current_opt_campaign/update_design_space/`, {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(data_design_space)
            });
            if(response.ok){
                const data = await response.json();
                if(data.msg === 'ok'){
                    setModifications(false);
                    setShowUpdateSuccess(true);
                    setValidated(true);
                }
                else {
                    setValidationMessage(data.msg)
                    setValidationWindow(true)
                }
            }
            if(!response.ok){
                throw new Error(`HTTP error ${response.status}`);
            }
            setIsLoading(false);
        } catch(err) {
            setIsLoading(false);
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }
    }

    async function saveDesignSpaceAsNew() {
        setIsLoading(true);
        try{
            let update = {
                uuid_design_space: uuidDesignSpace,
                uuid_opt_campaign: props.uuid_opt_campaign,
                cycle_id: props.cycleId,
                uuid_project: usr_session_ctx.session_info.uuid_current_project,
                design_space: { 
                    title: title, 
                    factors: factors
                } 
            }
            let headers = {
                'Content-Type': 'application/json',
                'auth0_user': user.sub,
                'uuid_tenant': usr_session_ctx.uuid_tenant
            };
            const response = await fetch(`${SERVER_URL}/current_opt_campaign/update_design_space_as_new/`, {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(update)
            });
            if(response.ok){
                const uuid_new_design_space = await response.json();
                if(uuid_new_design_space.msg === 'ok'){
                    setModifications(false);
                    setValidated(true);
                    setUuidDesignSpace(uuid_new_design_space.data)
                    setShowCreateSuccess(true);
                }
                else {
                    setValidationMessage(uuid_new_design_space.msg)
                    setValidationWindow(true)
                }
            }
            if(!response.ok){
                throw new Error(`HTTP error ${response.status}`);
            }
            setIsLoading(false);
        } catch(err) {
            setIsLoading(false);
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
            }
    }
    

    function onOkNoModifications(){
        setShowNoModificationDetected(false);
    }
    function onOkUpdate(){
        setShowUpdateSuccess(false);
    }

    function onOkCreate(){
        setShowCreateSuccess(false);
    }

    function handleExit(event){
        if(modifications===true) {
            setShowPopup(true);
        }
        else{
            props.exit();
        }
    }

    function onYes(){
        props.exit();
    }
    function onNo(){
        setShowPopup(false);
    }


    function handleTitle(event){
        setTitle(event.target.value);
        setModifications(true);
    }


    function handleUserInput(event){
        let parser = event.target.id.split('_');
        let factor_id = parser[1];
        let key = parser[0];
        if (parser.length > 2){
            factor_id = parser[2];
            key = parser[0]+'_'+parser[1];
        }
        const updatedFactors = [...factors];
        updatedFactors[factor_id] = {...updatedFactors[factor_id], [key]: event.target.value };
        setFactors(updatedFactors);
        setModifications(true);
    }


    function handleSaveValidation(){
        setValidationMessage([]);
        setValidationWindow(false);
        setTriggerSave(triggerSave+1);
    }

    useEffect(() => {
        // Make sure this is not called on first render
        if(triggerSave>0){
            handleSave();
        }
    }, [triggerSave])

    function handleExitValidation(){
        setValidationMessage([]);
        setValidationWindow(false);
    }

    function handleValidate(){
        handleSave()
    }



    let editor = (<></>)
    if(isLoading && !Exception){
        editor = (<div className = {'builder_canvas'} >
                    <div style = {{position:'absolute', top:'5px', display: 'flex', justifyContent: 'center', alignItems: 'center',  width:'100%', height:'100%'}}>
                        <CircleLoader loading={isLoading} size={40} color='var(--aixelo-green)' />
                    </div>
                </div>);
    }

    if(Exception){
        editor = (<>
                    <div className = {'builder_canvas'} >
                        <DisplayException>
                            {ExceptionMessage}
                        </DisplayException>  
                    </div>
                </>);
    }


    if(!isLoading && !Exception){

        let rquires_validation = <></>
        if(!validated){
            rquires_validation = (<>
                            <div style={{marginLeft:'20px', marginTop:'10px', marginBottom:'15px', display:'flex', justifyItems:'center'}}>
                                <button 
                                    // className={'actionButtonTiny'}
                                    className={'tableButton'}
                                    style={{marginTop:'0px', marginLeft: '0px', marginBottom:'px'}}
                                    onClick={handleValidate}
                                    >
                                    validate
                                </button>
                                <div style={{margin:'0px', padding:'0px', fontSize:'14px', color:'var(--aixelo-red)'}}>Changes in Experimental Workflow require Design Space (re)validation.</div>
                            </div>
                        </>);
        }

        if(!showPopup){
            editor = (<>
                        <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}} >
                            <h3 style={{marginTop:'10px', marginBottom:'5px' ,marginLeft:'20px', padding:'0px', color:'var(--aixelo-red)'}}>Design Space Editor <br/><span style={{fontWeight:'normal'}}>restricted to ensure compatibility throughout this optimization campaign</span></h3>
                            <div style = {{marginLeft: '20px', marginTop: '0px', marginBottom: '20px', fontSize: '12px', position: 'relative', width:'fit-content'}} >
                                Factors are derived from Experimental Workflow with uuid: {props.campaign_objects.uuid_experimental_setup}.
                            </div>
                            <div style={{display:'flex'}}>
                                <button className={'actionButtonSmall'} style={{marginLeft: '20px', right: '0px', marginBottom:'10px', width:'110px'}} onClick={handleSave}>Save</button>
                                <button className={'actionButtonSmall'} style={{marginLeft: '0px', right: '0px', marginBottom:'10px', width:'110px'}} onClick={handleExit}>Exit</button>
                                {/* <button className={'actionButtonSmall'} style={{marginLeft: '0px', right: '0px', marginBottom:'10px', width:'110px'}} onClick={enterWorkflowEditor}>Edit Workflow</button> */}
                            </div>
                            <input id='title' style = {{marginLeft:'20px', marginTop: '10px', marginBottom: '10px', border:'none', outline:'none', padding:'5px', position: 'relative',
                                                        borderLeft: '0.5px solid var(--aixelo-gray-light)', fontSize: '24px', fontWeight:'bold', width:'94%'}} 
                                            onChange = {handleTitle} value={title} autoComplete="off" type="text" placeholder="Enter Design Space Title"  name="project_title" />
                            <div style={{width: `${props.width * 0.95 - 40}px`, marginLeft:'20px', overflow:'auto'}}>
                                <FactorTableEditorCycle factors={factors} inputHandler={handleUserInput}/>
                            </div>   
                            {rquires_validation}                    
                        
                        </div>
                    </>
                    );
        }
        if(validationWindow) {
            let action_panel = (
                                <>
                                    <div style={{marginTop:'25px'}}>
                                        <div style={{marginLeft:'20px', marginBottom:'5px', fontSize:'14px'}}>Feel free to click 'Exit' to fix inconsistencies directly in Design Space Editor.</div>
                                        <div style={{display:'flex', margin:'0px'}}>
                                            <button className={'actionButtonSmall'} style={{marginLeft: '20px', right: '0px', marginBottom:'10px'}} onClick={handleSaveValidation}>Save</button>
                                            <button className={'actionButtonSmall'} style={{marginLeft: '0px', right: '0px', marginBottom:'10px'}} onClick={handleExitValidation}>Exit</button>
                                        </div>
                                    </div>
                                </>
                                );
        
            let show_validations = (<>
                                        <div style={{position: 'relative', marginLeft:'20px', marginTop:'25px', height:'fit-content', width:`${props.width * 0.95 - 60}px`, overflow:'auto'}}>
                                            <FactorTableValidation factors={factors} invalidFactors={validationMessage.err_msg_factors} inputHandler={handleUserInput}/>
                                        </div>
                                    </>);
            editor = (<>
                        <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}} >
                            <h3 style={{marginTop:'10px', marginLeft:'20px', marginBottom:'10px', padding:'0px', color:'var(--aixelo-red)'}}>Design Space Validation</h3>
                            <div style={{marginLeft:'20px', marginBottom:'0px', fontSize:'14px'}}>The following inconsistencies in the provided design space have been detected.</div>
                            {show_validations}
                            {action_panel}
                        </div>
                    </>);
        }

        if(showPopup){
            editor = (<>
                <div className = {'builder_canvas'}  style={{marginTop: '20px', height:props.height}}>
                    <YesNoPopup ypos={'60px'} handleYes={onYes} handleNo={onNo}>
                        Modifications detected. Exit without saving?
                    </YesNoPopup>  
                </div>
            </>);
        }
        else if(showPopupApplyAllCycles){
            editor = (<>
                <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}} >
                    <SelectOptionPopup ypos={'60px'} 
                        options = {['this cycle', 'all cycles']} 
                        actions = {[saveAsNew, apply2AllPrevCycles]}>
                        Do you want to apply the modifications to all previous cycles that are using the Design Space (uuid:{uuidDesignSpace}) or only to this and future cycles? 
                    </SelectOptionPopup>  
                </div>
            </>);
        }
        else if(showCreateSuccess){
            editor = (<>
                <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}} >
                    <InfoPopup ypos={'60px'} handleOk={onOkCreate} >
                        Successfully updated Design Space as new Object:
                            <div style={{textAlign: 'left'}}>
                                <ul>
                                    <li style={{marginBottom:'5px'}}>uuid: {uuidDesignSpace}</li>
                                </ul>
                       </div>
                    </InfoPopup>  
                </div>
            </>);
        }
        if(showUpdateSuccess){
            editor = (<>
                <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}} >
                    <InfoPopup ypos={'60px'} handleOk={onOkUpdate} >
                        Successfully updated Design Space (uuid:{uuidDesignSpace})
                    </InfoPopup>  
                </div>
            </>);
        }
        if(showNoModificationDetected){
            editor = (<>
                <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}}>
                    <InfoPopup ypos={'60px'} handleOk={onOkNoModifications} >
                       Object DesignSpace is already up to date.
                    </InfoPopup>  
                </div>
            </>);
        }
    }
    return (<>
                {editor}
            </>);
}

export default DesignSpaceEditorCycle